import { render, staticRenderFns } from "./complaintcreate.vue?vue&type=template&id=dde4df3c&scoped=true&"
import script from "./complaintcreate.vue?vue&type=script&lang=js&"
export * from "./complaintcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde4df3c",
  null
  
)

export default component.exports